<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="buildAssemblies">
        <dx-data-grid
            #dataGrid
            [keyExpr]="'id'"
            [dataSource]="buildAssemblies"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onOptionChanged)="onOptionChanged($event)"
            (onContentReady)="onContentReady($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="id" caption="Build #" width="80"></dxi-column>
            <dxi-column dataField="buildDate" caption="Date" width="100"></dxi-column>
            <dxi-column dataField="status.name" caption="Status" width="100"></dxi-column>
            <dxi-column dataField="vendor.companyName" caption="Vendor" width="200"></dxi-column>
            <dxi-column dataField="purchaseOrder.pONumber" caption="PO #" cellTemplate="linkTemplate" width="80"></dxi-column>
            <dxi-column dataField="createDate" caption="Created" width="100"></dxi-column>
            <dxi-column dataField="createdBy" width="200"></dxi-column>
            <dxi-column dataField="notes"></dxi-column>

            <div *dxTemplate="let item of 'columnTemplate'">
                <div style="font-weight: bold">{{ item.data.shipToLocation }}</div>
                <div>{{ item.data.shipToAddress1 }}</div>
                <div [hidden]="!item.data.shipToAddress2">{{ item.data.shipToAddress2 }}</div>
                <div>{{ item.data.shipToCity }}, {{ item.data.shipToState }} {{ item.data.shipToZip }} {{ item.data.shipToCountry }}</div>
            </div>
            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="[]" (click)="openPurchaseOrder(cell.data)">{{ cell.value || '' }}</a>
            </div>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="build-assembly-search-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-secondary me-2" (click)="open()">New</button>
                <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Open
                </button>
                <button
                    class="btn btn-danger ms-2"
                    (click)="delete()"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1 || dataGrid.instance.getSelectedRowsData()[0].statusId !== 1"
                >
                    Delete
                </button>
                <button class="btn btn-sm btn-warning ms-4" (click)="toggleCompleted()">
                    {{ showCompleted ? 'Hide Older Completed' : 'Show All' }}
                </button>
                <button class="btn btn-secondary ms-4" (click)="printReport()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Print Report</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="buildAssemblies" class="me-3"
                    ><strong
                        >{{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
